import axios from "axios";
import { environment } from "../config/environment";

export const addCartByCustomer = async (data) => {
  try {
    const response = await axios.post(environment.cart.add, data);
    return response.data;
  } catch (error) {
    console.error("Add to Cart API Error:", error);
    throw error;
  }
};

export const getCartProducts = async (data) => {
  try {
    const response = await axios.post(environment.cart.get, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateCartSize = async (payload) => {
  try {
    const response = await axios.post(environment.cart.updateSize, payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};
